import type { ReactElement, ReactNode } from 'react';
import { forwardRef, useState } from 'react';
import type { MenuProps } from '@chakra-ui/react';
import { MenuButton, Portal, useEventListener } from '@chakra-ui/react';

interface Props {
  Menu: (p: Omit<MenuProps, 'children'> & { children: ReactNode }) => ReactElement;
}

const ContextMenu = forwardRef<HTMLElement, Props>(({ Menu }: Props, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState([0, 0]);

  useEventListener('contextmenu', (e) => {
    if (
      ref &&
      typeof ref === 'object' &&
      (ref.current?.contains(e.target as HTMLElement) || e.target === ref.current)
    ) {
      e.preventDefault();
      if (isOpen) {
        setIsOpen(false);
        setTimeout(() => {
          setIsOpen(true);
        }, 0);
      } else {
        setIsOpen(true);
      }
      setPosition([e.pageX, e.pageY]);
    } else {
      setIsOpen(false);
    }
  });

  if (!isOpen) {
    return null;
  }

  return (
    <Portal>
      <Menu
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        isLazy={false}
        placement='right-start'
        offset={[0, 0]}
        gutter={0}>
        <MenuButton
          aria-hidden
          w={1}
          h={1}
          style={{
            position: 'absolute',
            left: position[0],
            top: position[1],
            cursor: 'default',
          }}
        />
      </Menu>
    </Portal>
  );
});

export default ContextMenu;
